import React from "react";
import EdButton from "../../../generic/edButton";
import EdModal from "../../../generic/edModal";
import "../../../../assets/scss/components/clientarea/serviceRequest/serviceRequest.scss";
import { apiService } from "../../../service/apiService";
import urlConfig, { config } from "../../../../config/domain";
import { asyncGetServiceRequest } from "../../../service/postLogin/clientProfileAPIService";
import {
  CreateServiceRequestDetails,
  ServiceClientValidation,
} from "../../../service/serviceRequest/srApiService";
import { getAccData } from "../../../service/login/loginService";
import Loader from "../../../generic/loader";
interface IHome {}

export const IncomeDeclarationConsent = (props: IHome) => {
  const [styles, setStyles] = React.useState({} as any);
  const [loader, setLoader] = React.useState<boolean>(false);
  const [error, setError] = React.useState<boolean>(false);

  function redirect(url: string) {
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      // If url is absolute
      window.location.href = url;
    }
  }
  const onSubmit = async () => {
    setLoader(true);
    const consentList = getAccData("cnsntLst");
    const dormantList = ["eqIncmDclr", "invAddress", "emailMob"];
    const checkList = consentList.map((list: any) => {
      if (dormantList.includes(list.name)) {
        return list;
      }
    });
    if (checkList.lenght > 1) {
      try {
        const payload = {
          requestType: "Account Reactivation",
          dpID: "None",
        };
        const serviceList = await asyncGetServiceRequest();
        let response = await ServiceClientValidation({
          subType: "Equity Dormant Reactivation",
        });
        const sr = serviceList.filter(
          (srReq: any) =>
            srReq.RequestType === "Equity Dormant Reactivation" &&
            [
              "Draft Saved",
              "Submitted",
              "AssignedtoHO",
              "InProcess",
              "PendingforEsign",
              "EsignVerified",
              "EsignSubmitted",
              "AssignedforEsignQC",
              "EsignVerified",
              "PushToTarget",
              "MemorandumPaymentPending",
            ].includes(srReq.RequestStatus)
        )[0];
        if (response === "BOAcoountNumber not found") {
          const accReact = await CreateServiceRequestDetails(payload);
          if (accReact && accReact.Message)
            localStorage.setItem(
              "accReactParentDetails",
              JSON.stringify(accReact)
            );
          else {
            setLoader(false);
            setError(true);
            return;
          }
        } else {
          localStorage.setItem("accReactParentDetails", JSON.stringify(sr));
        }
        setLoader(false);
        redirect(
          config.root + "/clientarea/service-request/account-reactivation"
        );
      } catch (err) {
        setLoader(false);
        setError(true);
      }
    } else {
      setLoader(false);
      redirect(
        config.root +
          "/clientarea/service-request/income-declaration?incomeConsent=incomeSRDropDown"
      );
    }
  };

  React.useEffect(() => {
    //window.location.replace(URLConfig.config.rootUrl);

    return () => {};
  }, []);
  function ModalBody(): React.ReactElement {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn income-declaration-phase1">
        <div className="modal-content">
          {loader ? (
            <div
              style={{
                textAlign: "center",
                paddingTop: "50px",
                paddingBottom: "50px",
              }}
            >
              <Loader size={50} color="blue"></Loader>
            </div>
          ) : (
            <div className="modal-body">
              {!error && (
                <div className="">
                  <div className="inProgress_wrap">
                    <div className="inProgress">
                      <i className="edel-icon-coins"></i>
                    </div>
                  </div>
                  <div className="textWrap">
                    <h1 className="comp_tit">Income Declaration Needed</h1>
                    <p className="comp_txt">
                      As per the exchange / Depository guidelines it is
                      mandatory to update Income details once a year for your
                      account. Ensure these details are not older than 12 months
                      as on date of updation{" "}
                    </p>
                  </div>
                  <div className="button">
                    <button
                      type="button"
                      className={
                        "ed_button common_button " +
                        styles.btn +
                        " " +
                        styles.btn_olink
                      }
                      onClick={() => onSubmit()}
                    >
                      <span>Proceed</span>
                    </button>
                  </div>
                </div>
              )}
              {error && (
                <div className="finalScreen consentPopup">
                  <div className="">
                    <div className="icon-wrap">
                      <i className="edel-icon-blocked"></i>
                    </div>
                  </div>
                  <div>
                    <p className="field-head text-center">Technical Issue</p>
                  </div>
                  <div>
                    <p className="field-subHead desc text-center grey-text">
                      Facing Some Technical Issue.Please Try Again Later.
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
  return <EdModal show={true} close={() => {}} children={ModalBody()} />;
};
